import { MultipartItem } from "../types/requestParamsModel";

export const makeUpCategoryRequest = (data) => {
    let multipartData = Array<MultipartItem>();
    let categoryData = {
        title: data.title,
        isActive: data.isActive
    };
    if (data.category) {
       categoryData.category = data.category 
    }

    if (data.photoUrl && data.imageUrl !== 2) {
        multipartData.push({ image: data.photoUrl, id: "photo" });
    } 

    multipartData.push({
        image: new Blob([JSON.stringify(categoryData)], { type: "application/json" }),
        id: "category",
    });
    return multipartData;
}